import React, { useState } from "react";
import "./Weather.css";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  let searching = true;
  function handleResponse(response) {
    let epochTime = response.data.time;
    let date = new Date(epochTime * 1000);
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let dayIndex = date.getDay();
    let nowDay = days[dayIndex];
    let nowDate = date.getDate();
    let nowMonth = date.getMonth() + 1;
    setWeatherData({
      ready: true,
      city: response.data.city,
      temp: Math.round(response.data.temperature.current),
      humidity: response.data.temperature.humidity,
      desc: response.data.condition.description,
      fullDate: `${nowDate}/${nowMonth}`,
      day: nowDay,
      wind: response.data.wind.speed,
      pressure: response.data.temperature.pressure,
      icon_url: response.data.condition.icon_url,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }
  function handleCityChange(event) {
    setCity(event.target.value);
  }

  function search() {
    const apiKey = "aa4oftad8baaee9e63b2667c02fe71b9";
    let apiURL = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}`;
    axios.get(apiURL).then(handleResponse);
  }

  if (weatherData.ready) {
    searching = false;
    return (
      <div className="page">
        <div className="box-zero">
          <div className="box-search">
            <form onSubmit={handleSubmit} className="search-form">
              <input
                className="search-bar"
                type="saerch"
                placeholder="Enter a city"
                autoFocus="on"
                onChange={handleCityChange}
              />
              <input className="search-button" type="submit" value="search" />
            </form>
          </div>
          <div className="box-one">
            <div className="box-two">
              <WeatherInfo className="weather-info" data={weatherData} />
            </div>
            <div className="box-three">
              <WeatherForecast searching={searching} city={weatherData.city} />
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    search();
    return <div>Loading...</div>;
  }
}
